import COUNTRIES from '../countries.translations'

import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story03.content'
import type { Article } from './types'

const t = translations
const dir = '/mine-my-phone/images/articles/story03'
const figure = articleFigure(dir)

export const story03: Article = {
  id: 3,
  slug: 'mining-in-the-atacama-desert',
  order: 3,
  title: t.title,
  excerpt: t.excerpt,
  image: `${dir}/01.jpg`,
  imageCaption: [...t.captions[0]],
  metal: articleMetal('lithium'),
  author: 'Paula Diaz Levi',
  region: [
    {
      name: t.regionName,
      country: COUNTRIES.chile,
      coordinates: [-68.25, -23.5],
      impact: 'human',
    },
  ],
  impactList: ['human', 'environmental'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      figure('02.jpg', t.captions[1]),
      { type: 'prose', blocks: [...t.prose[1]] },
      { type: 'prose', blocks: [...t.prose[2]] }, // The disappearance of the flamingos
      { type: 'quote', ...t.quotes[0] },
      { type: 'prose', blocks: [...t.prose[3]] },
      { type: 'prose', blocks: [...t.prose[4]] }, // A world hungry for lithium
      figure('03.jpg', t.captions[2]),
      { type: 'prose', blocks: [...t.prose[5]] },
      { type: 'prose', blocks: [...t.prose[6]] }, // Alternatives for a future with salt flats
      figure('04.jpg', t.captions[3]),
      { type: 'prose', blocks: [...t.prose[7]] },
    ],
  },
}
